import {
    USUARI_INICIALITZAR,
    USUARI_OMPLIR_USUARIS,
    USUARI_INTRODUCCIO_DESCARTAR_CANVIS,
    USUARI_INTRODUCCIO_MODIFICAR_CAMP,
    USUARI_OBTENIR_USUARIS_EN_CURS,
    USUARI_OBTENIR_USUARIS_FINALITZADA,
    USUARI_OMPLIR_ROLS,
    USUARI_OBTENIR_ROLS_EN_CURS,
    USUARI_OBTENIR_ROLS_FINALITZADA,
    USUARI_INTRODUCCIO_OMPLIR_DADES,
    USUARI_INTRODUCCIO_OBTENIR_DADES_EN_CURS,
    USUARI_INTRODUCCIO_OBTENIR_DADES_FINALITZADA,
    USUARI_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
    USUARI_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA,
    USUARI_INTRODUCCIO_MOSTRAR_ERRORS
} from './actionTypes';
import { errorConsultaServidor } from './error';

import { selectorFormulariDadesOriginals } from '../selectors/selector_usuari';

import { obtenirMunicipis } from '.';
import {
    fetchUsuaris,
    fetchRols,
    fetchDadesUsuari,
    fetchUsuariIntroduccioCrearUsuari,
    fetchUsuariIntroduccioEditarUsuari
} from '../commons/consultesServidor';

import { rutaUsuaris } from '../routes/routeConstants';

import {
    crearNotificacioSuccess,
    crearNotificacioNoShanModificatValorsAlFormulari,
    crearNotificacioWarning
} from '../commons/notificacio';

import {
    selectorFormulariIdUsuariSeleccionat,
    selectorFormulariDadesEditades,
    selectorFormulariNoShanModificatDades,
    selectorFormulariHiHaErrorsCamps
} from '../selectors/selector_usuari';

import {
    selectorLogin
} from '../selectors/selector_login';

export const onEnterUsuari = () => {
    return (dispatch => {
        dispatch(usuariInicialitzar());
        Promise.all([
            dispatch(usuariObtenirTots()),
            dispatch(obtenirMunicipis()),
            dispatch(usuariObtenirRols())
        ]);
    });
};

export const onEnterPerfil = () => {
    return (dispatch, getState) => {
        const usuariRegistrat = selectorLogin(getState());
        return Promise.all([
            dispatch(usuariIntroduccioSeleccionarUsuari(usuariRegistrat.idUsuari)),
            dispatch(obtenirMunicipis()),
            dispatch(usuariObtenirRols())
        ]);
    };
};


export const usuariInicialitzar = () => {
    return {
        type: USUARI_INICIALITZAR
    };
};

export const onLeavePerfil = usuariInicialitzar;

/**
 * Recupera tots els usuaris del servidor.
 */
export const usuariObtenirTots = () => {
    return (dispatch) => {
        dispatch(usuariObtenirUsuarisEnCurs());
        return fetchUsuaris()
            .then(usuaris => {
                dispatch(usuariOmplir(usuaris));
                dispatch(usuariObtenirUsuarisFinalitzada());
            },(errorServidor) => {
                dispatch(usuariObtenirUsuarisFinalitzada());
                const notificacioObtenirUsuarisError = 'Error obtenint els usuaris';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirUsuarisError));
            });
    };
};

const usuariObtenirUsuarisEnCurs = () => ({ type: USUARI_OBTENIR_USUARIS_EN_CURS});

const usuariObtenirUsuarisFinalitzada = () => ({ type: USUARI_OBTENIR_USUARIS_FINALITZADA});

const usuariOmplir = (usuaris) => {
    return {
        type: USUARI_OMPLIR_USUARIS,
        usuaris
    };
};

export const usuariIntroduccioDescartarCanvis = () => {
    return (dispatch, getState) => {
        const dadesOriginals = selectorFormulariDadesOriginals(getState());
        const accioUsuariIntroduccioDescartarCanvis = {
            type: USUARI_INTRODUCCIO_DESCARTAR_CANVIS,
            originals: dadesOriginals
        };
        dispatch(accioUsuariIntroduccioDescartarCanvis);
    };
};

export const usuariIntroduccioModificarCamp = (idCamp, valor) => {
    return {
        type: USUARI_INTRODUCCIO_MODIFICAR_CAMP,
        idCamp,
        valor
    };
};

export const usuariIntroduccioOmplirDades = (idUsuari, dades, estacions, esActiu) => {
    return {
        type: USUARI_INTRODUCCIO_OMPLIR_DADES,
        idUsuari,
        dades,
        estacions,
        esActiu
    };
};

const usuariIntroduccioObtenirDadesEnCurs = () => ({ type: USUARI_INTRODUCCIO_OBTENIR_DADES_EN_CURS });
const usuariIntroduccioObtenirDadesFinalitzada = () => ({ type: USUARI_INTRODUCCIO_OBTENIR_DADES_FINALITZADA });

export const usuariIntroduccioSeleccionarUsuari = (idUsuari, callbackExit) => {

    return (dispatch) => {
        dispatch(usuariIntroduccioObtenirDadesEnCurs());

        return fetchDadesUsuari(idUsuari)
            .then(respostaServidor => {
                const { dades, estacions, esActiu } = respostaServidor;
                dispatch(usuariIntroduccioObtenirDadesFinalitzada());
                dispatch(usuariIntroduccioOmplirDades(idUsuari, dades, estacions, esActiu));
                if (callbackExit) {
                    callbackExit();
                }
            }, (errorServidor) => {
                dispatch(usuariIntroduccioObtenirDadesFinalitzada());
                const notificacioObtenirDadesUsuariError = 'Error obtenint les dades de l\'usuari';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirDadesUsuariError));
            });
    };

};

const usuariObtenirRols = () => {

    return (dispatch) => {

        dispatch(usuariObtenirRolsEnCurs());
        return fetchRols()
            .then(
                rols => {
                    dispatch(usuariOmplirRols(rols));
                    dispatch(usuariObtenirRolsFinalitzada());
                },
                (errorServidor) => {
                    dispatch(usuariObtenirRolsFinalitzada());
                    const notificacioObtenirRolsError = 'Error obtenint els rols';
                    dispatch(errorConsultaServidor(errorServidor, notificacioObtenirRolsError));
                }
            );

    };
};

const usuariObtenirRolsEnCurs = () => ({ type: USUARI_OBTENIR_ROLS_EN_CURS});

const usuariObtenirRolsFinalitzada = () => ({ type: USUARI_OBTENIR_ROLS_FINALITZADA});

const usuariOmplirRols = (rols) => {
    return {
        type: USUARI_OMPLIR_ROLS,
        rols
    };
};

const usuariIntroduccioEnviarFormulariEnCurs = () => ({ type: USUARI_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS});
const usuariIntroduccioEnviarFormulariFinalitzada = () => ({ type: USUARI_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA});
const usuariIntroduccioMostrarErrors = () => ({ type: USUARI_INTRODUCCIO_MOSTRAR_ERRORS });

export const usuariIntroduccioEnviarFormulari = (routerHistory) => {
    return (dispatch, getState) => {

        const estat = getState();

        if (selectorFormulariNoShanModificatDades(estat)) {
            crearNotificacioNoShanModificatValorsAlFormulari();
            return;
        }

        if (selectorFormulariHiHaErrorsCamps(estat)) {
            dispatch(usuariIntroduccioMostrarErrors());
            const notificacioErrorDadesObligatoriesAdvertencia = 'El formulari conté errors';
            crearNotificacioWarning(notificacioErrorDadesObligatoriesAdvertencia);
            return;
        }

        const idUsuari = selectorFormulariIdUsuariSeleccionat(estat);
        const dadesEditades = selectorFormulariDadesEditades(estat);
        const codiUsuari = dadesEditades.codi;

        let promesa;
        let rutaRedireccionamentSiInsercioOk;
        let missatgeNotificacioExit;
        let missatgeNotificacioError;

        dispatch(usuariIntroduccioEnviarFormulariEnCurs());

        if (idUsuari === null) { // creant estació
            promesa = fetchUsuariIntroduccioCrearUsuari(dadesEditades);
            missatgeNotificacioExit = 'Usuari creat correctament';
            missatgeNotificacioError = 'Error creant l\'usuari';
            rutaRedireccionamentSiInsercioOk = rutaUsuaris;
        } else { // editant estació
            promesa = fetchUsuariIntroduccioEditarUsuari(idUsuari, dadesEditades);
            missatgeNotificacioExit = `Usuari amb codi "${codiUsuari}" editat correctament`;
            missatgeNotificacioError = 'Error editant l\'usuari';
            rutaRedireccionamentSiInsercioOk = rutaUsuaris;
        }

        return promesa
            .then(() => {
                dispatch(usuariIntroduccioEnviarFormulariFinalitzada());
                crearNotificacioSuccess(missatgeNotificacioExit);
                routerHistory.push(rutaRedireccionamentSiInsercioOk);
            }, (errorServidor) => {
                dispatch(usuariIntroduccioEnviarFormulariFinalitzada());
                dispatch(errorConsultaServidor(errorServidor, missatgeNotificacioError));
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/usuari.js